//Javascript for GCP custom flow
  (function(selectedVariant) {
    
    var gcpForm = {
      
      /**
       * Settings for the form. This includes any fields that are required, option selectors for the product variant, and the default image for the gift card made through GCP and if it should be forced.
       */
      settings: {
        
        /**
         * Required fields used by the showForm and hideForm functions. These fields are necessary to allow form submission while the form is hidden because of the "send to self" toggle.
         */
        requiredElements: [
          document.querySelector("#gcp_recipient_name input"),
          document.querySelector("#gcp_sender_name input"),
          document.querySelector("#gcp_recipient_email input"),
        ],
        
        /**
         * Product variant selectors. These are necessary to allow the setImage function to accurately change the image based on the selected variant.
         */
        productOptionInputs:{
          option1: document.querySelectorAll('[name="option1"]'),
          option2: document.querySelectorAll('[name="option2"]'),
          option3: document.querySelectorAll('[name="option3"]'),
        },
        
        /**
         * Default gift card image. Used as a fallback for the gift card image if setImage fails, or if useDefaultImage is true.
         */
        defaultImage: "https://cdn.shopify.com/s/files/1/0601/8783/6659/products/Aero-Press-gift-card.png?v=1669766990",
        
        /**
         * Switch for forcing use of the default gift card image. While set to true, the gift card image will be set to the value of defaultImage and not change.
         *
         * This should be set to false if the gift card product has an option selector for images.
         */
        useDefaultImage: false
        
      },

      /*
       * State variables.
       * 
       * product: the currenty shopify product object.
       * variantId: starting variant id for the product.
       */
      state: {
        product: null,
        variantId: null,
      },

      /**
       * Gets the shopify product, then sets up all initial variables.
       */
      scaffold: function() {

        gcpForm.functions.getProduct()
        .then(function(product) {
          gcpForm.state.product = product;
          gcpForm.functions.setCurrentVariantId();
          gcpForm.events();
          if(gcpForm.settings.useDefaultImage) gcpForm.elements.selectedImage.setAttribute("value", gcpForm.settings.defaultImage);
          else gcpForm.functions.setImage();
        });
        
      },
      
      /**
       * Initializer.
       */
      init: function() {

        gcpForm.scaffold();
        
      },

      /**
       * Form Elements.
       *
       * sendToSelfInput, sendNowInput, sendLaterInput: Toggle elements, will have event listeners attached to them. 
       * datePicker: Container element of datePickerField. Will be hidden by sendNowInput and shown by sendLaterInput.
       * datePickerField: Form field for the date picker. Will have it's requirements.
       * selectedImage: Gift Card Image field. GCP will use this field as the selected card image.
       * recipientDetailsSection: Form container. will be hidden or shown by the sendToSelf
       */
      elements: {
        sendToSelfInput:document.querySelector("#gcp_send_to_self input"),
        sendNowInput:document.querySelector("#sendNow"),
        sendLaterInput:document.querySelector("#sendLater"),
        datePicker:document.querySelector("#gcp_delivery_date"),
        datePickerField:document.querySelector("#gcp_delivery_date input"),
        selectedImage:document.querySelector('[name="properties[_gcp_selected_card_image]"]'),
        recipientDetailsSection:document.querySelector("#gcp_recipient_details_section"),
      },

      /**
       * Sets up all event listeners
       */
      events: function() {
        //Send To Self
        gcpForm.elements.sendToSelfInput.addEventListener('change', gcpForm.functions.toggleSendToSelf);
        //Send Now
        gcpForm.elements.sendNowInput.addEventListener('click', gcpForm.functions.hideDatePicker);
        //Send Later
        gcpForm.elements.sendLaterInput.addEventListener('click', gcpForm.functions.showDatePicker);
        //Product Options
        if(!gcpForm.settings.useDefaultImage){
          gcpForm.functions.addVariantEventListeners(gcpForm.settings.productOptionInputs.option1);
          gcpForm.functions.addVariantEventListeners(gcpForm.settings.productOptionInputs.option2);
          gcpForm.functions.addVariantEventListeners(gcpForm.settings.productOptionInputs.option3);
        }
      },

      functions: {

        /**
         * sets the ID from the product id hidden field
         */
        setCurrentVariantId: function() {
          gcpForm.state.variantId = document.querySelector('[name="id"]').value;
        },

        /**
         * Requests the product from the Shopify API and returns a promise.
         */
        getProduct: function() {

          return new Promise(function(resolve, reject) {
            fetch(window.location.pathname + '.json')
            .then(function(r){return r.json()})
            .then(resolve)
            .catch(reject)
            ;
          });
          
        },

        /**
         * Iterates through an array of HTML elements and adds event listeners to trigger setImage on any inputs.
         *
         * @params option array
         */
        addVariantEventListeners: function(option) {
          
          if(option === null){
            return false;
          }
          
          //var elements = option.querySelectorAll('input');
          
          for(el of option){
            if (typeof(el) !== "object" || el === null) return false;
            el.addEventListener('click', gcpForm.functions.setImage);
          }
          
          return true;
          
          
        },

        /**
         * Shows the datePicker field.
         */
        showDatePicker: function() {
          gcpForm.functions.showElement(gcpForm.elements.datePicker);
          gcpForm.functions.makeRequired([gcpForm.elements.datePickerField]);
        },
        
        /**
         * Hides the datePicker field.
         */
        hideDatePicker: function() {
          gcpForm.functions.hideElement(gcpForm.elements.datePicker);
          gcpForm.functions.makeOptional([gcpForm.elements.datePickerField]);
        },


        /**
         * Takes an element, then sets it's display to none.
         *
         * @params el element
         */
        hideElement: function(el) {

          if (typeof(el) == 'undefined') {
            return false;
          }
          
          el.style.display = "none";
        
        },
        
        /**
         * Takes an element, then sets it's display to block.
         *
         * @params el element
         */
        showElement: function(el) {

          if (typeof(el) == 'undefined') {
            return false;
          }
          
          el.style.display = "block";
        
        },

        /**
         * Takes an array of elements and sets a required attribute.
         *
         * @params els array
         */
        makeRequired: function(els) {

          if (typeof(els) === 'undefined') {
            return false;
          }
          
          for(el of els){
            if(typeof el === 'object') el.setAttribute("required","");
          }

          return true;
        
        },

        /**
         * Takes an array of elements and removes their required attribute.
         *
         * @params els array
         */
        makeOptional: function(els) {

          if (typeof(els) === 'undefined') {
            return false;
          }
          
          for(el of els){
            if(typeof el === 'object') el.removeAttribute("required");
          }

          return true;
        
        },

        /**
         * Calls hideElement and makeOptional or showElement and makeRequired
         */
        toggleSendToSelf: function() {
          if(this.checked){
            gcpForm.elements.sendNowInput.click();
            gcpForm.functions.hideElement(gcpForm.elements.recipientDetailsSection);
            gcpForm.functions.makeOptional(gcpForm.settings.requiredElements);
          } else {
            gcpForm.functions.showElement(gcpForm.elements.recipientDetailsSection);
            gcpForm.functions.makeRequired(gcpForm.settings.requiredElements);
          }
        },

        /**
         * Takes a container element of options and searches them for a checked input.
         * Returns the checked input or null if input is not found.
         * 
         * @param {NodeList} optionInputs
         * @returns {string|null} optionValue
         */
        findCheckedOption: function(optionInputs) {
          
          var optionValue = null;
          
          if (
            optionInputs === null || 
            typeof optionInputs === undefined || 
            optionInputs.length === 0 ||
            typeof optionInputs !== "object"
          ) {
            return optionValue;
          }

          optionInputs.forEach(function(optionInput) {

            if(optionInput.checked) {
              optionValue = optionInput.value;
            }
            
          });


          return optionValue;
          
        },

        /**
         * uses findCheckedOption to get user input, then attempts to find the variant corrisponding to the selected options.
         * if unsuccessful, defaultImage will be used as a fallback.
         * Will throw an error if defaultImage is not set.
         */
        setImage: function() {
          //checked options
          var option1 = gcpForm.functions.findCheckedOption(gcpForm.settings.productOptionInputs.option1),
              option2 = gcpForm.functions.findCheckedOption(gcpForm.settings.productOptionInputs.option2),
              option3 = gcpForm.functions.findCheckedOption(gcpForm.settings.productOptionInputs.option3);

          try{
            //finding the variant
            const currentVariant = gcpForm.state.product.product.variants.find(function(variant){
              return (
                variant.option1 === option1 &&
                variant.option2 === option2 &&
                variant.option3 === option3
              );
            });
            
            //throws an exception if no variant is found
            if(typeof currentVariant === 'undefined') throw(new Error("No matching variants found"));
            if(typeof (currentVariant.image_id) === 'undefined') throw(new Error("Failed to obtain variant"));
            
            //goes to find the image with an id matching the variant's image_id
            gcpForm.state.product.product.images.find(function(image){
              if(image.id === currentVariant.image_id){
                gcpForm.elements.selectedImage.setAttribute("value", image.src);
              }
            });

            //catch error then try to set default image.
          } catch(err){
            console.warn("An error occured", err);
            try {
              gcpForm.elements.selectedImage.setAttribute("value", gcpForm.settings.defaultImage);
            } catch(err) {
              console.error("Default image is undefined! ", error);
            }
          }
        }

      }
      
    };

    gcpForm.init();

  })();